import { breakpoint } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/AlternativeTransportLeftPanel";
import { IncidentsAndStopsPanels } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/IncidentsAndStopsPanels";
import { LogAndGpsPanels } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/LogAndGpsPanels";
import { SimpleStickyController } from "features/CenterContent/VehicleDetails/shared/SimpleStickyController";
import { hideOnWidthClassname } from "shared/utils/hideOnWidth";
import { useTheme } from "styled-components";
import {
  AlternativeTransportItinerary,
  AlternativeTransportItineraryStop,
  AlternativeTransportVehicle,
  StopReference,
} from "shared/types/alternativeTransport";
import { useMemo } from "react";
import { Box } from "shared/components/Spor";

interface AlternativeTransportLeftPanelProps {
  vehicle: AlternativeTransportVehicle;
}

export const AlternativeTransportLeftPanelScroll = ({
  vehicle,
}: AlternativeTransportLeftPanelProps) => {
  const theme = useTheme();

  const getDistributionStopPlace = (
    itinerary: AlternativeTransportItinerary | null,
  ) =>
    itinerary
      ? [...itinerary.stops, ...(itinerary.returnStops ?? [])]
          .filter((stop) => !!stop.stopReference.nsrStopPlace)
          .map((stop) => stop.stopReference.nsrStopPlace)
          .join(",")
      : "";

  const distributionStopReferences: Array<StopReference> = useMemo(() => {
    const stops = vehicle?.itinerary?.stops ?? [];
    const returnStops = vehicle?.itinerary?.returnStops ?? [];
    return [...stops, ...returnStops].map(
      (value: AlternativeTransportItineraryStop) => value.stopReference,
    );
  }, [vehicle]);

  const distributionStopPlaces = useMemo(
    () => getDistributionStopPlace(vehicle.itinerary),
    [vehicle],
  );

  return (
    <>
      <Box
        className={hideOnWidthClassname("hide-on-small", breakpoint)}
        overflowY="auto"
      >
        <SimpleStickyController
          stickyBackground={theme.colorBackgroundMain}
          headerHeight="54px"
          gap="6px"
        >
          <IncidentsAndStopsPanels
            vehicle={vehicle}
            distributionStopReferences={distributionStopReferences}
          />
        </SimpleStickyController>
      </Box>
      <Box
        className={hideOnWidthClassname("hide-on-small", breakpoint)}
        overflowY="auto"
      >
        <SimpleStickyController
          stickyBackground={theme.colorBackgroundMain}
          headerHeight="54px"
          gap="6px"
        >
          <LogAndGpsPanels
            vehicle={vehicle}
            distributionStopPlaces={distributionStopPlaces}
          />
        </SimpleStickyController>
      </Box>

      <Box
        className={hideOnWidthClassname("hide-on-large", breakpoint)}
        overflowY="auto"
      >
        <SimpleStickyController
          stickyBackground={theme.colorBackgroundMain}
          headerHeight="54px"
          gap="6px"
        >
          <IncidentsAndStopsPanels
            vehicle={vehicle}
            distributionStopReferences={distributionStopReferences}
          />
          <LogAndGpsPanels
            vehicle={vehicle}
            distributionStopPlaces={distributionStopPlaces}
          />
        </SimpleStickyController>
      </Box>
    </>
  );
};
